import { LYNX_CONNECT } from '../actionTypes';

const initialState = {
  invoices: {
    content: [],
    totalElements: 0,
    meta: {
      vendors: [],
      locations: [],
    },
    addNewInvoiceStatus: '',
    invoiceDetail: {
      vendorName: null,
      invoiceNumber: null,
      totalAmount: null,
      billedTo: null,
      invoiceDate: null,
      subTotalAmount: null,
      fileName: null,
      scanDate: null,
      status: null,
      location: null,
    },
  },
  locations: {
    content: [],
    totalElements: 0,
  },
  validate: {
    content: [],
    totalElements: 0,
    editRowSyncStatus: {
      status: '',
      lineItemId: null,
      syncStatus: null,
    },
  },
  exist: {
    content: [],
    totalElements: 0,
    history: [],
    editRowSyncStatus: {
      status: '',
      lineItemId: null,
      syncStatus: null,
    },
    singleLineItem: [],
    posStatus: '',
  },
  pdf: null,
  loading: false,
  subLoading: {
    invoiceDetail: false,
    pdfData: false,
    auditTimeline: false,
  },
  auditLogTimeline: [],
};

export default (state = initialState, action) => {
  let newSingleLineItem;
  switch (action.type) {
    case LYNX_CONNECT.SET_INVOICE_CONTENT:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          content: action.payload,
        },
      };
    case LYNX_CONNECT.SET_INVOICE_TOTAL_ELEMENTS:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          totalElements: action.payload,
        },
      };
    case LYNX_CONNECT.SET_INVOICE_META:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          meta: {
            vendors: action.payload.vendors,
            locations: action.payload.locations,
          },
        },
      };
    case LYNX_CONNECT.SET_INVOICE_DETAIL:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          invoiceDetail: action.payload,
        },
      };
    case LYNX_CONNECT.SET_INVOICE_NEW_STATUS:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          addNewInvoiceStatus: action.payload,
        },
      };
    case LYNX_CONNECT.SET_LOCATION_CONTENT:
      return {
        ...state,
        locations: {
          ...state.locations,
          content: action.payload,
        },
      };
    case LYNX_CONNECT.SET_LOCATION_TOTAL_ELEMENTS:
      return {
        ...state,
        locations: {
          ...state.locations,
          totalElements: action.payload,
        },
      };
    case LYNX_CONNECT.SET_VALIDATE_CONTENT:
      return {
        ...state,
        validate: {
          ...state.validate,
          content: action.payload,
        },
      };
    case LYNX_CONNECT.SET_VALIDATE_TOTAL_ELEMENTS:
      return {
        ...state,
        validate: {
          ...state.validate,
          totalElements: action.payload,
        },
      };
    case LYNX_CONNECT.SET_VALIDATE_EDIT_ROW_SYNC_STATUS:
      return {
        ...state,
        validate: {
          ...state.validate,
          editRowSyncStatus: action.payload,
        },
      };
    case LYNX_CONNECT.SET_EXIST_CONTENT:
      return {
        ...state,
        exist: {
          ...state.exist,
          content: action.payload,
        },
      };
    case LYNX_CONNECT.SET_EXIST_CONTENT_TOTAL_ELEMENTS:
      return {
        ...state,
        exist: {
          ...state.exist,
          totalElements: action.payload,
        },
      };
    case LYNX_CONNECT.SET_EXIST_HISTORY:
      return {
        ...state,
        exist: {
          ...state.exist,
          history: action.payload,
        },
      };
    case LYNX_CONNECT.SET_EXIST_EDIT_ROW_SYNC_STATUS:
      return {
        ...state,
        exist: {
          ...state.exist,
          editRowSyncStatus: action.payload,
        },
      };
    case LYNX_CONNECT.SET_EXIST_SINGLE_LINE_ITEM_VALUE:
      if (Array.isArray(action.payload)) {
        newSingleLineItem = action.payload;
      } else {
        newSingleLineItem = [...state.exist.singleLineItem, action.payload];
      }
      return {
        ...state,
        exist: {
          ...state.exist,
          singleLineItem: newSingleLineItem,
        },
      };
    case LYNX_CONNECT.RESET_VALIDATE_LINE_ITEMS:
      return {
        ...state,
        validate: {
          content: [],
          totalElements: 0,
          editRowSyncStatus: {
            status: '',
            lineItemId: null,
            syncStatus: null,
          },
        },
      };
    case LYNX_CONNECT.RESET_EXIST_LINE_ITEMS:
      return {
        ...state,
        exist: {
          content: [],
          totalElements: 0,
          history: [],
          editRowSyncStatus: {
            status: '',
            lineItemId: null,
            syncStatus: null,
          },
          singleLineItem: [],
          posStatus: '',
        },
      };
    case LYNX_CONNECT.RESET_LOCATIONS:
      return {
        ...state,
        locations: {
          content: [],
          totalElements: 0,
        },
      };
    case LYNX_CONNECT.RESET_INVOICES:
      return {
        ...state,
        invoices: {
          content: [],
          totalElements: 0,
          meta: {
            vendors: [],
            locations: [],
          },
          addNewInvoiceStatus: '',
        },
      };
    case LYNX_CONNECT.EXIST_UPDATE_POS_STATUS:
      return {
        ...state,
        exist: {
          ...state.exist,
          posStatus: action.payload,
        },
      };
    case LYNX_CONNECT.SET_INVOICE_PDF:
      return {
        ...state,
        pdf: action.payload,
      };
    case LYNX_CONNECT.SET_MAIN_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case LYNX_CONNECT.SET_SUB_LOADING:
      return {
        ...state,
        subLoading: {
          ...state.subLoading,
          [action.payload.name]: action.payload.loading,
        },
      };
    case LYNX_CONNECT.SET_AUDIT_LOG:
      return {
        ...state,
        auditLogTimeline: action.payload,
      };
    default:
      return state;
  }
};
